// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"MainContent_sectionWrapper__SdD51"};